import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import MemberAnnouncementsPage from "@/pages/member/MemberAnnouncementsPage";

export const Route = createFileRoute("/member/announcements")({
  head: () => pageHead("Member · Announcements", "AKIVA member · announcements portal.", "/member/announcements", true),
  component: MemberAnnouncementsPage,
});
